import React from "react";

const About = () => {
  return (
    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* About Me Section */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-center mb-4">About Me</h2>
        <p className="text-justify text-gray-700">
          Hi, my name is Anna Sophia Brokuf! I'm a research assistant at Hochschule Ruhr-West in Bottrop currently working on different chatbot-projects. Additionally, I'm pursuing a master's degree in computer science. Previously I studied applied computer science where I started to work at the FabLab of the Ruhr West University.
        </p>
        <p className="text-justify text-gray-700 mt-4">
          I am passionate about learning new things, that's why I'm looking forward to take part in the FabAcademy!
        </p>
      </div>

      {/* Student Agreement Section */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-center mb-4">Student Agreement</h2>

        <h3 className="text-2xl font-bold mb-2">The Fab Academy is responsible for:</h3>
        <ul className="list-disc ml-8 mb-6 text-gray-700">
          <li>Teaching principles and practices of digital fabrication</li>
          <li>Arranging lectures, recitations, meetings, and events for the class</li>
          <li>Evaluating and providing feedback on student work</li>
          <li>Offering clear standards for completing assignments</li>
          <li>Certifying and archiving student progress</li>
          <li>Supervising class preparation</li>
          <li>Reviewing prospective students, instructors, and labs</li>
          <li>Providing central staff and infrastructure for students, instructors, and labs</li>
          <li>Fund-raising for costs not covered by student tuition</li>
          <li>Managing and reporting on the program's finances, results, and impacts</li>
          <li>Publicizing the program</li>
          <li>Promoting a respectful environment free of harassment and discrimination</li>
        </ul>

        <h3 className="text-2xl font-bold mb-2">I am a Fab Academy student, responsible for:</h3>
        <ul className="list-disc ml-8 text-gray-700">
          <li>Attending class lectures and participating in reviews</li>
          <li>Developing and documenting projects assigned to introduce and demonstrate skills</li>
          <li>Honestly reporting on my work, and appropriately attributing the work of others</li>
          <li>Working safely</li>
          <li>Leaving workspaces in the same (or better) condition than I found them</li>
          <li>Participating in the upkeep of my lab</li>
          <li>Ensuring that my tuition to cover local and central class costs is covered</li>
          <li>Following locally applicable health and safety guidance</li>
          <li>Promoting a respectful environment free of harassment and discrimination</li>
        </ul>
        <p>Signed by committing this file in my repository,</p>
       <p> Anna Brokuf</p>
      </div>
    </div>
  );
};

export default About;
